import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { PeoplesTabController } from '@mainrepo/app/core/controller/PeoplesTabController';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { GlobalService } from 'projects/common-repo/src/app/core/services/global.service';
import { KEY_CODE } from 'projects/common-repo/src/app/core/services/universal.service';
import { AppEvents } from '../../../../../../common-repo/src/app/core/utils/app-events';
import { ExperiencePeopleTabComponent } from '../experience-people-tab/experience-people-tab.component';

@Component({
  standalone:true,
  selector: 'app-enable-people-tab-confirmation',
  templateUrl: './enable-people-tab-confirmation.component.html',
  styleUrls: ['./enable-people-tab-confirmation.component.scss'],
  imports:[DependenciesModule,ExperiencePeopleTabComponent]
})
export class EnablePeopleTabConfirmationComponent implements OnInit {
  public controller :any;
  public implRef:any;
  showPeopleTabConfimation:boolean = false;
  universalService:any;
  selectedOption:any = "enable";
  showEnableConfirmation:boolean = false;
  @Output() closePopUp = new EventEmitter();
  cleverTapEventsService: any;

  constructor(public globalService:GlobalService) { 
    this.setEnvObjects(globalService);
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && ( this.showEnableConfirmation || this.showPeopleTabConfimation)) {
      this.enablePeopleTab(false,'closeBtn');
    }else if (event.key === "Enter" && this.selectedOption == "skip" && this.showPeopleTabConfimation){
      this.enablePeopleTab(false,'skipBtn');
    }else if (event.key === "Enter" && this.selectedOption == "enable" && this.showPeopleTabConfimation){
      this.enablePeopleTab(true,'enableNBtn');
    }

    if (event.keyCode === KEY_CODE.RIGHT_ARROW) {
      $('#skip').addClass('no-bg');
      $('#enable').removeClass('no-bg');
      this.selectedOption = "enable"
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW) {
      $('#enable').addClass('no-bg');
      $('#skip').removeClass('no-bg');
      this.selectedOption = "skip"
    }
  }

  ngOnInit(): void {
    this.controller = PeoplesTabController.getInstance(this.globalService);
    this.implRef = this.controller.peoplesTabImplementation;
    AppEvents.globalObservable.subscribe(event => {
      if(event["showEnablePeopleTabPopUp"]){
        this.initComp();
      }else if(event["closeAll"] || event["showEnablePeopleTabPopUp"] == false){
        this.showPeopleTabConfimation = false;
        this.showEnableConfirmation = false;
      }
    })
  }

  initComp(){
    this.showPeopleTabConfimation = true;
    this.cleverTapEventsService.peopleConsentPopupEvents('Shown');
    //this.cleverTapEventsService.peopleTabScreenViewed('faceGroupingConsent');
    $('#enable').removeClass('no-bg');
    $('#skip').addClass('no-bg');
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
  }

  learnMore() {
    this.cleverTapEventsService.peopleConsentPopupEvents('Learn More');
  }

  async enablePeopleTab(value,location){
    if(!value){
      if(location == 'closeBtn'){
        this.cleverTapEventsService.peopleConsentPopupEvents('Close');
      }else{
        this.cleverTapEventsService.peopleConsentPopupEvents('Skip');
      }
      this.closePopUp.emit();
      console.log("closing the pop up and no change")
    }else{
      var enabled = await this.controller.enablePeopleTabFeature();
      if(enabled["fgpEnabled"]){
        this.cleverTapEventsService.peopleConsentPopupEvents('Agreed');
        this.showEnableConfirmation = true
        this.showPeopleTabConfimation = false;
        console.log("enabling  people tab feature",enabled);
      }else{
        this.showPeopleTabConfimation = false;
        this.universalService.showToast(TOAST["GENERIC_ERROR"],"error");
      }
     
    }
  }

}
